<script setup lang="ts">
// Review-only side card (under Documents): list, add and remove policy-level endorsements. Persistence is owned by the parent.
import { ref } from 'vue';

defineProps<{ endorsements: any[] }>();
const emit = defineEmits<{ (e: 'add'): void; (e: 'remove', endorsement: any): void }>();

const open = ref(true);
const dec = (s: any): any => typeof s === 'string'
    ? s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#0?39;|&apos;/g, "'").replace(/&amp;/g, '&')
    : s;
</script>

<template>
    <div class="ssq-endo-card">
        <button type="button" class="ssq-endo-head" @click="open = !open">
            <span>Policy endorsements <span class="ssq-endo-count" v-if="endorsements.length">{{ endorsements.length }}</span></span>
            <em class="far" :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"></em>
        </button>
        <div v-if="open" class="ssq-endo-body">
            <ul class="ssq-endo-list" v-if="endorsements.length">
                <li v-for="(end, i) in endorsements" :key="i">
                    <div class="ssq-endo-info">
                        <div class="ssq-endo-code">{{ dec(end.Code) }}</div>
                        <div class="ssq-endo-sum" v-if="end.Summary">{{ dec(end.Summary) }}</div>
                    </div>
                    <button type="button" class="ssq-endo-rm" title="Remove endorsement" @click="emit('remove', end)"><em class="far fa-trash-can"></em></button>
                </li>
            </ul>
            <p v-else class="ssq-endo-empty">No endorsements added.</p>
            <button type="button" class="btn out ssq-endo-add" @click="emit('add')"><em class="far fa-plus mr-1"></em> Add endorsement</button>
        </div>
    </div>
</template>
